module.exports={
    "两次输入的密码必须一致": "As senhas devem corresponder!",
    "取消": "Cancelar",
    "如验证出现问题，请点击": "Problema de verificação",
    "如验证出现问题，请联系orcalivecs@asiainnovations.com": "Se houver algum problema com a verificação, entre em contato com orcalivecs@asiainnovations.com",
    "如验证出现问题，请联系upcs@asiainnovations.com": "Se houver algum problema com a verificação, entre em contato com upcs@asiainnovations.com",
    "密码修改成功": "A senha foi modificada com sucesso",
    "密码格式错误": "Formato de senha incorreto",
    "密码由6-20位由数字和字母组成": "A senha deve conter letras e números de 6 a 20 caracteres de comprimento",
    "恭喜您密码重置成功": "A senha redefinida com sucesso",
    "恭喜您已成功激活帐户": "Parabéns pela ativação bem-sucedida da sua conta",
    "知道了": "OK",
    "确认修改": "Confirme modificação",
    "网络连接有误, 请稍后再试": "Problema de conexão à internet, tente novamente mais tarde",
    "联系客服": "Suporte ao cliente",
    "请再次输入密码": "Digite sua senha novamente",
    "请返回UpVoice中重新进行邮箱验证": "Volte para UpVoice e autentique novamente o email",
    "请返回Up直播中重新进行邮箱验证": "Volte para Uplive e autentique novamente o email",
    "请返回虎鲸直播中重新进行邮箱验证": "Volte para Orcalive e autentique novamente o email",
    "请重新设定登录密码": "Redefina a senha de login",
    "请重新设置密码": "Redefina a senha",
    "赶快返回UpVoice中与全球潮人互动吧": "Volte para UpVoice e vamos festejar!",
    "赶快返回Up直播中与全球潮人互动吧！": "Volte para Uplive e vamos festejar!",
    "赶快返回虎鲸直播中与全球潮人互动吧": "Volte para Orcalive e vamos festejar!",
    "重置密码失败": "Falha ao redefinir a senha",
    "验证失败": "Falha na verificação",
    "验证成功": "Verificação bem sucedida"
};



// WEBPACK FOOTER //
// ./js/lang/ptpt.js